<template>
  <div class="one-column-view">
    <div class="article-content">
      <h1>{{ careerContent.title }}</h1>
      <div v-html="careerContent.description"></div>
      <h5 class="text-dark mt-3">
        <strong>{{ $t("careers.responsibilities") }}</strong>
      </h5>
      <ul>
        <li v-for="(item, key) in careerContent.responsibilities" :key="key">
          {{ item }}
        </li>
      </ul>
      <div class="application-form">
        <JobApplicationForm />
      </div>
    </div>
  </div>
</template>

<script>
import JobApplicationForm from "@/components/JobApplicationForm.vue";

export default {
  components: {
    JobApplicationForm,
  },
  data() {
    return {
      careerContent: "",
      writerContent: {
        title: "Marketing Content Writer",
        description:
          "We are looking to hire a dedicated content writer to create content for blogs, articles, product descriptions, social media, and the company website. The content writer's responsibilities include evaluating analytics to adjust content as needed, regularly updating the company's website, and promoting the company blog by pitching articles to various third-party platforms.",
        responsibilities: [
          "Writing clear, compelling copy for various mediums (e.g. ads, websites, newsletters)",
          "Conducting thorough research and interviews",
          "Working with creative professionals to build marketing projects and campaigns",
          "Interpret copywriting briefs to understand project requirements",
          "Collaborate with designers, PR and other professionals on large- and small-scale marketing projects (e.g. email campaigns and landing pages)",
          "Conduct high-quality research and interviews",
          "Edit and proofread copy as needed",
          "Use SEO principles to maximize copy’s reach",
        ],
      },
      writerContentCN: {
        title: "营销文案作家",
        description:
          "我们正在寻找专门的内容作家来为博客、文章、产品描述、社交媒体和公司网站创建内容。内容作者的职责包括评估分析以根据需要调整内容、定期更新公司网站以及通过向各种第三方平台投放文章来推广公司博客。",
        responsibilities: [
          "为各种媒体（例如广告、网站、时事通讯）撰写清晰、引人入胜的文案",
          "进行深入的研究和采访",
          "与创意专业人士合作建立营销项目和活动",
          "解读文案简报以了解项目要求",
          "与设计师、公关和其他专业人士合作开展大型和小型营销项目（例如电子邮件活动和登录页面）",
          "进行高质量的研究和访谈",
          "根据需要编辑和校对副本",
          "使用 SEO 原则来最大化副本的覆盖面",
        ],
      },
      specialistContent: {
        title: "Digital Marketing Specialist",
        description:
          "This job is responsible for generating and nurturing leads, deploying and tracking both digital and traditional marketing campaigns, testing successes of those campaigns, and iterating through a data‐driven approach to improve marketing effectiveness. Ensures implementation of marketing strategies are in line with goals for online products or services. Develops marketing strategies to attract customers to company website, online presence and promote online products or services. Leads the development of e-marketing content and exploration of sales channels. Analyzes online statistics and helps identify the best practice to optimize online marketing performance",
        responsibilities: [
          "Planning and executing strategies to drive online traffic to the company website",
          "Develop and manage online marketing strategies",
          "Write and develop engaging content to generate organic traffic to the site",
          "Utilizing a range of techniques including but not limited to paid search, SEO, and PPC",
          "Overseeing the social media strategy",
          "Managing online brand and product campaigns to raise brand awareness",
          "Responsibility for planning and budgetary control of all digital marketing",
          "Evaluating customer research, market conditions, and competitor data",
          "Review new technologies and keep the company at the forefront of developments in digital marketing",
          "Review new technologies and keep the company updated on the new developments in digital marketing.",
        ],
      },
      specialistContentCN: {
        title: "数字营销专家",
        description:
          "这项工作负责产生和培养潜在客户，部署和跟踪数字和传统营销活动，测试这些活动的成功，并通过数据驱动的方法进行迭代以提高营销效率。确保营销策略的实施符合在线产品或服务的目标。制定营销策略以吸引客户访问公司网站、在线形象并推广在线产品或服务。引领电子营销内容的开发和销售渠道的探索。分析在线统计数据并帮助确定优化在线营销绩效的最佳实践",
        responsibilities: [
          "规划和执行策略以增加公司网站的在线流量",
          "制定和管理在线营销策略",
          "编写和开发引人入胜的内容以产生网站的自然流量",
          "利用一系列技术，包括但不限于付费搜索、SEO 和 PPC 监督社交媒体策略",
          "管理在线品牌和产品活动以提高品牌知名度",
          "负责所有数字营销的计划和预算控制",
          "评估客户研究、市场状况和竞争对手数据",
          "审查新技术并使公司始终处于数字营销发展的最前沿",
          "审查新技术并让公司了解数字营销的新发展",
        ],
      },
      developerContent: {
        title: "Blockchain Developer",
        description:
          "<strong>Front-End Technologies:</strong><br /><ul><li>Web fundamentals like Web3, HTML/HTML5, JavaScript/AJAX, and CSS/CSS3</li><li>CSS preprocessors like Sass or LESS</li><li>JavaScript frameworks like Vue, React, etc.</li></ul><strong>Back-End Technologies:</strong><br /><ul><li>API design and development, web services such as REST, SOAP, WCF, Web API,GraphQL</li><li>Server-side languages like PHP, JavaScript, etc.</li><li>Database technologies like MySQL, PostgreSQL, and MongoDB.</li><li>Web server technologies like Node.js, Apache, Nginx, Redis, etc.</li><li>Cloud computing platforms such as Amazon Web Services, Google Compute Engine,etc.</li></ul><strong>Blockchain Technologies:</strong><br /><ul><li>Own the responsibility for analysis, design and implementation of blockchaindevelopment</li><li>Solid programming skills, with strong experience in Solidity anddecentralized architectures through DAO's, oracles, and other supportinginfrastructure</li><li>Writing, testing, and deploying Ethereum smart contracts and building theSystem design (oracles, services, etc) around them</li><li>Supporting the development of DApps as part of our platform</li></ul>",
        responsibilities: [
          "Work with our CTO and a team of developers and provide insight into our web growth strategy, spanning web products, data analytics, testing, and automation",
          "Build-out our modern web architecture to enable us to more quickly ship new features into production at scale",
          "Develop and maintain our web framework to serve the needs of different areas of the business and user personas",
          "Implement new logging, data collection, and storage architectures to support our voracious appetite for data and data-driven insights",
          "Own web development projects from backend to the presentation layer",
          "Work through a variety of technical challenges that will require creativity and close collaboration across internal functions",
          "Own the deployment and release process",
          "Release early, release often (we love continuous integration)",
          "Research technical approaches and drive decisions on platform components",
          "Strong skills in testing, source control, documentation, refactoring, and troubleshooting",
          "Provide hands-on engineering collaboration and leadership to the team",
          "Become a key member in Coin’s blockchain strategy and consensus related inquiries",
          "Collaborate with engineering and product teams to prioritize, estimate cost, spec upcoming features and productize customer requests",
          "Work closely with company leadership to identify upcoming opportunities and risks while implementing and maintaining our blockchain infrastructure",
        ],
      },
      developerContentCN: {
        title: "区块链开发者",
        description:
          "<strong>前端技术要求：</strong><ul><li>Web 基础知识，例如 Web3、HTML/HTML5、JavaScript/AJAX 和 CSS/CSS3</li><li>CSS 预处理器，如 Sass 或 LESS</li><li>Vue、React 等 JavaScript 框架</li></ul><strong>后端技术要求：</strong><ul><li>API设计与开发，REST、SOAP、WCF、Web API、GraphQL等Web服务</li><li>服务器端语言，如 PHP、JavaScript 等</li><li>MySQL、PostgreSQL 和 MongoDB 等数据库技术</li><li>Web 服务器技术，如 Node.js、Apache、Nginx、Redis 等</li><li>云计算平台，如亚马逊网络服务、谷歌计算引擎等</li></ul><strong>区块链技术要求：</strong><ul><li>负责区块链开发的分析、设计和实施</li><li>扎实的编程技能，通过 DAO、预言机和其他支持基础设施在 Solidity 和去中心化架构方面拥有丰富的经验</li><li>编写、测试和部署以太坊智能合约并围绕它们构建系统设计（预言机、服务等）</li><li>作为我们平台的一部分，支持 DApp 的开发</li></ul>",
        responsibilities: [
          "与我们的 CTO 和开发人员团队合作，深入了解我们的网络增长战略，涵盖网络产品、数据分析、测试和自动化",
          "构建我们的现代 Web 架构，使我们能够更快地将新功能大规模投入生产",
          "开发和维护我们的 Web 框架，以满足不同业务领域和用户角色的需求",
          "实施新的日志记录、数据收集和存储架构，以支持我们对数据和数据驱动洞察力的贪婪需求",
          "拥有从后端到表现层的 Web 开发项目",
          "应对各种需要创造力和跨内部职能部门密切协作的技术挑战",
          "拥有部署和发布流程",
          "尽早发布，经常发布（我们喜欢持续集成）",
          "研究技术方法并推动平台组件的决策",
          "强大的测试、源代码控制、文档、重构和故障排除技能",
          "为团队提供动手工程协作和领导",
          "成为 Coin 区块链战略和共识相关咨询的关键成员",
          "与工程和产品团队合作，确定优先级、估算成本、指定即将推出的功能并将客户要求产品化",
          "与公司领导层密切合作，在实施和维护我们的区块链基础设施的同时识别即将到来的机遇和风险",
        ],
      },
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getCurrentPage();
  },
  methods: {
    getCurrentPage() {
      // 从API获取职位相关信息，然后根据当前页面地址与语言显示相应内容
      const currentPath = this.$router.history.current.path.substring(1);
      if (this.$i18n.locale == "en") {
        switch (currentPath) {
          case "pages/careers-writer":
            this.careerContent = this.writerContent;
            break;
          case "pages/careers-specialist":
            this.careerContent = this.specialistContent;
            break;
          case "pages/careers-developer":
            this.careerContent = this.developerContent;
            break;

          default:
            break;
        }
      } else {
        switch (currentPath) {
          case "pages/careers-writer":
            this.careerContent = this.writerContentCN;
            break;
          case "pages/careers-specialist":
            this.careerContent = this.specialistContentCN;
            break;
          case "pages/careers-developer":
            this.careerContent = this.developerContentCN;
            break;

          default:
            break;
        }
      }
    },
  },
  watch: {
    "$i18n.locale": function () {
      this.getCurrentPage();
    },
  },
};
</script>

<style scoped>
.career-banner {
  height: 336px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>
